import { useQuery } from "@tanstack/react-query";
import { supabasePublic } from "@/integrations/supabase/publicClient";

export function useOrgPlanPublic(organizationId?: string | null) {
    const result = useQuery({
        queryKey: ["org-plan", organizationId],
        queryFn: async () => {
            if (!organizationId) return "starter"; // safe default

            const { data, error } = await supabasePublic
                .from("organizations")
                .select("plan_key")
                .eq("id", organizationId)
                .maybeSingle();

            if (error) {
                // In production, fail silently to default footer. In dev, log error.
                if (import.meta.env.DEV) {
                    console.error("Public org plan fetch error:", error);
                }
                return "starter";
            }

            return data?.plan_key || "starter";
        },
        enabled: !!organizationId,
        staleTime: 1000 * 60 * 60, // 1 hour
    });

    return {
        ...result,
        planKey: result.data
    };
}
